import { makeObservable, observable, action, runInAction, makeAutoObservable } from 'mobx';
import { leadHandler } from '../handlers/leadHandlers';
import SnackbarStore from './SnackbarStore';
import { severity } from '../utils/severity';
import LoadingProgressStore from './LoadingProgressStore';

class LeadStore {
  pipelines = [];
  priorities = [];
  workflowStatusByPipeLine = [];
  workflowStatusList = [];
  workflowSubStatusList = [];
  workflowSubStatusListByWorkflowId = [];
  getPipelinesSuccess = false;
  newPipeline = null;
  newPipelineSuccess = false;
  updatePipelineSuccess = false;
  isLeadExist = null;
  newLead = null;
  newLeadSuccess = false;
  leadsDeletionStatus = false;
  leadDuplicateStatus = false;
  createLeadActionStatus = false;
  createLeadCallStatus = false;
  createLeadPaymentAuditStatus = false;
  leadsNotifyStatus = false;
  leadAssignedStatus = false;
  leadSummaryByStatus = [];
  refreshLeadersBoard = 1;
  refreshLeadDetails = 1;
  updateLeadSuccess = false;
  updateCustomerKycSuccess = false;
  leadDetails = null;
  leadTimeLines = [];
  leadsList = [];
  leadsListColumns = [];
  error = '';
  canPerformMassStatusUpdate = false;
  leadsMassStatusUpdateStatus = false;
  updateClientInfoStatus = false;
  updateProcessAndProcedureCompletedStatus = false;
  updateSiteDetailsStatus = false;
  updateAdditionalServiceRequiredStatus = false;
  updatePcpDetailsStatus = false;
  updateClientPersonalDetailsStatus = false;
  updateFeedbackAndSuggestionsStatus = false;
  updateClientDesignDetailStatus = false;
  updateClientResidentialBuildingDetailStatus = false;
  updateClientConstructionSpecificationsStatus = false;

  constructor() {
    makeAutoObservable(this);
  }

  async getPipelines() {
    leadHandler
      .getPipeLines()
      .then((response) => {
        runInAction(() => {
          this.pipelines = response.data;
          this.getPipelinesSuccess = true;
        });
      })
      .catch((err) => {
        runInAction(() => {
          this.error = err;
        });
        console.error(err);
        throw err;
      });
  }

  async getPriorities() {
    leadHandler
      .getPriorities()
      .then((response) => {
        runInAction(() => {
          this.priorities = [...response.data];
        });
      })
      .catch((err) => {
        runInAction(() => {
          this.error = err;
        });
        console.error(err);
      });
  }

  async getWorkflowStatusByPipeLineId(pipelineId) {
    leadHandler
      .getWorkflowStatusByPipeLineId(pipelineId)
      .then((response) => {
        runInAction(() => {
          this.workflowStatusByPipeLine = [...response.data];
        });
      })
      .catch((err) => {
        runInAction(() => {
          this.error = err;
        });
        console.error(err);
      });
  }

  async checkLeadExists(pipelineId, phoneNumber) {
    leadHandler
      .checkLeadExists(pipelineId, phoneNumber)
      .then((response) => {
        runInAction(() => {
          this.workflowStatusByPipeLine = [...response.data];
        });
      })
      .catch((err) => {
        runInAction(() => {
          this.error = err;
        });
        console.error(err);
      });
  }

  async checkLeadExists(pipelineId, phoneNumber) {
    leadHandler
      .checkLeadExists(pipelineId, phoneNumber)
      .then((response) => {
        runInAction(() => {
          this.isLeadExist = response.data.returnValue;
        });
      })
      .catch((err) => {
        runInAction(() => {
          this.error = err;
          console.error(err);
        });
      });
  }

  async getLeadSummaryOnStatus(pipelineId, fromDate, toDate) {
    leadHandler
      .getLeadSummaryOnStatus(pipelineId, fromDate, toDate)
      .then((response) => {
        runInAction(() => {
          this.leadSummaryByStatus = [...response.data];
        });
      })
      .catch((err) => {
        runInAction(() => {
          this.error = err;
        });
        console.error(err);
      });
  }

  async getWorkflowStatus() {
    leadHandler
      .getWorkflowStatus()
      .then((response) => {
        runInAction(() => {
          this.workflowStatusList = [...response.data];
        });
      })
      .catch((err) => {
        runInAction(() => {
          this.error = err;
        });
        console.error(err);
      });
  }

  async getWorkflowSubStatus() {
    leadHandler
      .getWorkflowSubStatus()
      .then((response) => {
        runInAction(() => {
          this.workflowSubStatusList = [...response.data];
        });
      })
      .catch((err) => {
        runInAction(() => {
          this.error = err;
        });
        console.error(err);
      });
  }

  async getWorkflowSubStatusByWorkflowId(workFlowId, pipeLineId) {
    leadHandler
      .getWorkflowSubStatusByWorkflowId(workFlowId, pipeLineId)
      .then((response) => {
        runInAction(() => {
          this.workflowSubStatusListByWorkflowId = [...response.data];
        });
      })
      .catch((err) => {
        runInAction(() => {
          this.error = err;
        });
        console.error(err);
      });
  }

  async getDetailedLead(leadId) {
    LoadingProgressStore.toggleIsLoading(true);
    leadHandler
      .getDetailedLead(leadId)
      .then((response) => {
        runInAction(() => {
          this.leadDetails = { ...response.data };
        });
      })
      .catch((err) => {
        runInAction(() => {
          this.error = err;
        });
        console.error(err);
      })
      .finally(() => {
        LoadingProgressStore.toggleIsLoading(false);
      });
  }

  async getLeadStatusTimeLine(getDetailedLead) {
    LoadingProgressStore.toggleIsLoading(true);
    leadHandler
      .getLeadStatusTimeLine(getDetailedLead)
      .then((response) => {
        runInAction(() => {
          this.leadTimeLines = response.data;
        });
      })
      .catch((err) => {
        runInAction(() => {
          this.error = err;
        });
        console.error(err);
      })
      .finally(() => {
        LoadingProgressStore.toggleIsLoading(false);
      });
  }

  async createPipeline(payload) {
    LoadingProgressStore.toggleIsLoading(true);
    return leadHandler
      .createPipeLine(payload)
      .then((response) => {
        runInAction(() => {
          this.newPipeline = response.data;
          this.newPipelineSuccess = true;
          SnackbarStore.toggleSnackbar(true, severity.success, 'Pipeline created successfully');
        });
      })
      .catch((err) => {
        runInAction(() => {
          this.error = err;
          console.error(err);
        });
      })
      .finally(() => {
        this.newPipelineSuccess = false;
        LoadingProgressStore.toggleIsLoading(false);
      });
  }

  async updatePipeLine(payload) {
    LoadingProgressStore.toggleIsLoading(true);
    return leadHandler
      .updatePipeLine(payload)
      .then((response) => {
        runInAction(() => {
          this.updatePipelineSuccess = true;
          SnackbarStore.toggleSnackbar(true, severity.success, 'Pipeline updated successfully');
        });
      })
      .catch((err) => {
        runInAction(() => {
          this.error = err;
          console.error(err);
        });
      })
      .finally(() => {
        this.updatePipelineSuccess = false;
        LoadingProgressStore.toggleIsLoading(false);
      });
  }

  async createLead(payload) {
    LoadingProgressStore.toggleIsLoading(true);
    return leadHandler
      .createLead(payload)
      .then((response) => {
        runInAction(() => {
          this.newLead = response.data;
          this.newLeadSuccess = true;
          this.refreshLeadersBoard += 1;
          SnackbarStore.toggleSnackbar(true, severity.success, 'Lead created successfully');
        });
      })
      .catch((err) => {
        runInAction(() => {
          LoadingProgressStore.toggleIsLoading(false);
          this.error = err;
          this.newLeadSuccess = false;
          console.error(err);
        });
      })
      .finally(() => {
        this.newLeadSuccess = false;
        LoadingProgressStore.toggleIsLoading(false);
      });
  }

  async updateLead(payload) {
    LoadingProgressStore.toggleIsLoading(true);
    return leadHandler
      .updateLead(payload)
      .then((response) => {
        runInAction(() => {
          this.updateLeadSuccess = true;
          this.refreshLeadDetails += 1;
          SnackbarStore.toggleSnackbar(true, severity.success, 'Lead updated successfully');
        });
      })
      .catch((err) => {
        runInAction(() => {
          LoadingProgressStore.toggleIsLoading(false);
          this.error = err;
          console.error(err);
        });
      })
      .finally(() => {
        this.updateLeadSuccess = false;
        LoadingProgressStore.toggleIsLoading(false);
      });
  }

  async updateCustomerKyc(payload) {
    LoadingProgressStore.toggleIsLoading(true);
    return leadHandler
      .updateCustomerKyc(payload)
      .then((response) => {
        runInAction(() => {
          this.updateCustomerKycSuccess = true;
          this.refreshLeadDetails += 1;
          SnackbarStore.toggleSnackbar(true, severity.success, 'Kyc updated successfully');
        });
      })
      .catch((err) => {
        runInAction(() => {
          this.error = err;
          console.error(err);
        });
      })
      .finally(() => {
        this.updateCustomerKycSuccess = false;
        LoadingProgressStore.toggleIsLoading(false);
      });
  }

  async createCustomerKyc(payload) {
    LoadingProgressStore.toggleIsLoading(true);
    return leadHandler
      .createCustomerKyc(payload)
      .then((response) => {
        runInAction(() => {
          this.updateCustomerKycSuccess = true;
          this.refreshLeadDetails += 1;
          SnackbarStore.toggleSnackbar(true, severity.success, 'Kyc updated successfully');
        });
      })
      .catch((err) => {
        runInAction(() => {
          this.error = err;
          console.error(err);
        });
      })
      .finally(() => {
        this.updateCustomerKycSuccess = false;
        LoadingProgressStore.toggleIsLoading(false);
      });
  }

  async updateClientInfo(payload) {
    LoadingProgressStore.toggleIsLoading(true);
    return leadHandler
      .updateClientInfo(payload)
      .then((response) => {
        runInAction(() => {
          this.updateClientInfoStatus = true;
          this.refreshLeadDetails += 1;
          SnackbarStore.toggleSnackbar(true, severity.success, 'Client info updated successfully');
        });
      })
      .catch((err) => {
        runInAction(() => {
          this.error = err;
          console.error(err);
        });
      })
      .finally(() => {
        this.updateClientInfoStatus = false;
        LoadingProgressStore.toggleIsLoading(false);
      });
  }

  async createClientInfo(payload) {
    LoadingProgressStore.toggleIsLoading(true);
    return leadHandler
      .createClientInfo(payload)
      .then((response) => {
        runInAction(() => {
          this.updateClientInfoStatus = true;
          this.refreshLeadDetails += 1;
          SnackbarStore.toggleSnackbar(true, severity.success, 'Client info created successfully');
        });
      })
      .catch((err) => {
        runInAction(() => {
          this.error = err;
          console.error(err);
        });
      })
      .finally(() => {
        this.updateClientInfoStatus = false;
        LoadingProgressStore.toggleIsLoading(false);
      });
  }

  async updateProcessAndProcedureCompleted(payload) {
    LoadingProgressStore.toggleIsLoading(true);
    return leadHandler
      .updateProcessAndProcedureCompleted(payload)
      .then((response) => {
        runInAction(() => {
          this.updateProcessAndProcedureCompletedStatus = true;
          this.refreshLeadDetails += 1;
          SnackbarStore.toggleSnackbar(true, severity.success, 'Process & Procedure updated successfully');
        });
      })
      .catch((err) => {
        runInAction(() => {
          this.error = err;
          console.error(err);
        });
      })
      .finally(() => {
        this.updateProcessAndProcedureCompletedStatus = false;
        LoadingProgressStore.toggleIsLoading(false);
      });
  }

  async createProcessAndProcedureCompleted(payload) {
    LoadingProgressStore.toggleIsLoading(true);
    return leadHandler
      .createProcessAndProcedureCompleted(payload)
      .then((response) => {
        runInAction(() => {
          this.updateProcessAndProcedureCompletedStatus = true;
          this.refreshLeadDetails += 1;
          SnackbarStore.toggleSnackbar(true, severity.success, 'Process & Procedure created successfully');
        });
      })
      .catch((err) => {
        runInAction(() => {
          this.error = err;
          console.error(err);
        });
      })
      .finally(() => {
        this.updateProcessAndProcedureCompletedStatus = false;
        LoadingProgressStore.toggleIsLoading(false);
      });
  }

  async updateSiteDetails(payload) {
    LoadingProgressStore.toggleIsLoading(true);
    return leadHandler
      .updateSiteDetails(payload)
      .then((response) => {
        runInAction(() => {
          this.updateSiteDetailsStatus = true;
          this.refreshLeadDetails += 1;
          SnackbarStore.toggleSnackbar(true, severity.success, 'Site details updated successfully');
        });
      })
      .catch((err) => {
        runInAction(() => {
          this.error = err;
          console.error(err);
        });
      })
      .finally(() => {
        this.updateSiteDetailsStatus = false;
        LoadingProgressStore.toggleIsLoading(false);
      });
  }

  async createSiteDetails(payload) {
    LoadingProgressStore.toggleIsLoading(true);
    return leadHandler
      .createSiteDetails(payload)
      .then((response) => {
        runInAction(() => {
          this.updateSiteDetailsStatus = true;
          this.refreshLeadDetails += 1;
          SnackbarStore.toggleSnackbar(true, severity.success, 'Site details updated successfully');
        });
      })
      .catch((err) => {
        runInAction(() => {
          this.error = err;
          console.error(err);
        });
      })
      .finally(() => {
        this.updateSiteDetailsStatus = false;
        LoadingProgressStore.toggleIsLoading(false);
      });
  }

  async updateAdditionalServiceRequired(payload) {
    LoadingProgressStore.toggleIsLoading(true);
    return leadHandler
      .updateAdditionalServiceRequired(payload)
      .then((response) => {
        runInAction(() => {
          this.updateAdditionalServiceRequiredStatus = true;
          this.refreshLeadDetails += 1;
          SnackbarStore.toggleSnackbar(true, severity.success, 'Additional services required updated successfully');
        });
      })
      .catch((err) => {
        runInAction(() => {
          this.error = err;
          console.error(err);
        });
      })
      .finally(() => {
        this.updateAdditionalServiceRequiredStatus = false;
        LoadingProgressStore.toggleIsLoading(false);
      });
  }

  async createAdditionalServiceRequired(payload) {
    LoadingProgressStore.toggleIsLoading(true);
    return leadHandler
      .createAdditionalServiceRequired(payload)
      .then((response) => {
        runInAction(() => {
          this.updateAdditionalServiceRequiredStatus = true;
          this.refreshLeadDetails += 1;
          SnackbarStore.toggleSnackbar(true, severity.success, 'Additional services required updated successfully');
        });
      })
      .catch((err) => {
        runInAction(() => {
          this.error = err;
          console.error(err);
        });
      })
      .finally(() => {
        this.updateAdditionalServiceRequiredStatus = false;
        LoadingProgressStore.toggleIsLoading(false);
      });
  }

  async updatePcpDetails(payload) {
    LoadingProgressStore.toggleIsLoading(true);
    return leadHandler
      .updatePcpDetails(payload)
      .then((response) => {
        runInAction(() => {
          this.updatePcpDetailsStatus = true;
          this.refreshLeadDetails += 1;
          SnackbarStore.toggleSnackbar(true, severity.success, 'Details updated successfully');
        });
      })
      .catch((err) => {
        runInAction(() => {
          this.error = err;
          console.error(err);
        });
      })
      .finally(() => {
        this.updatePcpDetailsStatus = false;
        LoadingProgressStore.toggleIsLoading(false);
      });
  }

  async createPcpDetails(payload) {
    LoadingProgressStore.toggleIsLoading(true);
    return leadHandler
      .createPcpDetails(payload)
      .then((response) => {
        runInAction(() => {
          this.updatePcpDetailsStatus = true;
          this.refreshLeadDetails += 1;
          SnackbarStore.toggleSnackbar(true, severity.success, 'Details updated successfully');
        });
      })
      .catch((err) => {
        runInAction(() => {
          this.error = err;
          console.error(err);
        });
      })
      .finally(() => {
        this.updatePcpDetailsStatus = false;
        LoadingProgressStore.toggleIsLoading(false);
      });
  }

  async updateClientPersonalDetails(payload) {
    LoadingProgressStore.toggleIsLoading(true);
    return leadHandler
      .updateClientPersonalDetails(payload)
      .then((response) => {
        runInAction(() => {
          this.updateClientPersonalDetailsStatus = true;
          this.refreshLeadDetails += 1;
          SnackbarStore.toggleSnackbar(true, severity.success, 'Details updated successfully');
        });
      })
      .catch((err) => {
        runInAction(() => {
          this.error = err;
          console.error(err);
        });
      })
      .finally(() => {
        this.updateClientPersonalDetailsStatus = false;
        LoadingProgressStore.toggleIsLoading(false);
      });
  }

  async createClientPersonalDetails(payload) {
    LoadingProgressStore.toggleIsLoading(true);
    return leadHandler
      .createClientPersonalDetails(payload)
      .then((response) => {
        runInAction(() => {
          this.updateClientPersonalDetailsStatus = true;
          this.refreshLeadDetails += 1;
          SnackbarStore.toggleSnackbar(true, severity.success, 'Details updated successfully');
        });
      })
      .catch((err) => {
        runInAction(() => {
          this.error = err;
          console.error(err);
        });
      })
      .finally(() => {
        this.updateClientPersonalDetailsStatus = false;
        LoadingProgressStore.toggleIsLoading(false);
      });
  }

  async updateFeedbackAndSuggestions(payload) {
    LoadingProgressStore.toggleIsLoading(true);
    return leadHandler
      .updateFeedbackAndSuggestions(payload)
      .then((response) => {
        runInAction(() => {
          this.updateFeedbackAndSuggestionsStatus = true;
          this.refreshLeadDetails += 1;
          SnackbarStore.toggleSnackbar(true, severity.success, 'Details updated successfully');
        });
      })
      .catch((err) => {
        runInAction(() => {
          this.error = err;
          console.error(err);
        });
      })
      .finally(() => {
        this.updateFeedbackAndSuggestionsStatus = false;
        LoadingProgressStore.toggleIsLoading(false);
      });
  }

  async createFeedbackAndSuggestions(payload) {
    LoadingProgressStore.toggleIsLoading(true);
    return leadHandler
      .createFeedbackAndSuggestions(payload)
      .then((response) => {
        runInAction(() => {
          this.updateFeedbackAndSuggestionsStatus = true;
          this.refreshLeadDetails += 1;
          SnackbarStore.toggleSnackbar(true, severity.success, 'Details updated successfully');
        });
      })
      .catch((err) => {
        runInAction(() => {
          this.error = err;
          console.error(err);
        });
      })
      .finally(() => {
        this.updateFeedbackAndSuggestionsStatus = false;
        LoadingProgressStore.toggleIsLoading(false);
      });
  }

  async updateClientDesignDetail(payload) {
    LoadingProgressStore.toggleIsLoading(true);
    return leadHandler
      .updateClientDesignDetail(payload)
      .then((response) => {
        runInAction(() => {
          this.updateClientDesignDetailStatus = true;
          this.refreshLeadDetails += 1;
          SnackbarStore.toggleSnackbar(true, severity.success, 'Details updated successfully');
        });
      })
      .catch((err) => {
        runInAction(() => {
          this.error = err;
          console.error(err);
        });
      })
      .finally(() => {
        this.updateClientDesignDetailStatus = false;
        LoadingProgressStore.toggleIsLoading(false);
      });
  }

  async createClientDesignDetail(payload) {
    LoadingProgressStore.toggleIsLoading(true);
    return leadHandler
      .createClientDesignDetail(payload)
      .then((response) => {
        runInAction(() => {
          this.updateClientDesignDetailStatus = true;
          this.refreshLeadDetails += 1;
          SnackbarStore.toggleSnackbar(true, severity.success, 'Details updated successfully');
        });
      })
      .catch((err) => {
        runInAction(() => {
          this.error = err;
          console.error(err);
        });
      })
      .finally(() => {
        this.updateClientDesignDetailStatus = false;
        LoadingProgressStore.toggleIsLoading(false);
      });
  }

  async updateClientResidentialBuildingDetail(payload) {
    LoadingProgressStore.toggleIsLoading(true);
    return leadHandler
      .updateClientResidentialBuildingDetail(payload)
      .then((response) => {
        runInAction(() => {
          this.updateClientResidentialBuildingDetailStatus = true;
          this.refreshLeadDetails += 1;
          SnackbarStore.toggleSnackbar(true, severity.success, 'Details updated successfully');
        });
      })
      .catch((err) => {
        runInAction(() => {
          this.error = err;
          console.error(err);
        });
      })
      .finally(() => {
        this.updateClientResidentialBuildingDetailStatus = false;
        LoadingProgressStore.toggleIsLoading(false);
      });
  }

  async createClientResidentialBuildingDetail(payload) {
    LoadingProgressStore.toggleIsLoading(true);
    return leadHandler
      .createClientResidentialBuildingDetail(payload)
      .then((response) => {
        runInAction(() => {
          this.updateClientResidentialBuildingDetailStatus = true;
          this.refreshLeadDetails += 1;
          SnackbarStore.toggleSnackbar(true, severity.success, 'Details updated successfully');
        });
      })
      .catch((err) => {
        runInAction(() => {
          this.error = err;
          console.error(err);
        });
      })
      .finally(() => {
        this.updateClientResidentialBuildingDetailStatus = false;
        LoadingProgressStore.toggleIsLoading(false);
      });
  }

  async updateClientConstructionSpecifications(payload) {
    LoadingProgressStore.toggleIsLoading(true);
    return leadHandler
      .updateClientConstructionSpecifications(payload)
      .then((response) => {
        runInAction(() => {
          this.updateClientConstructionSpecificationsStatus = true;
          this.refreshLeadDetails += 1;
          SnackbarStore.toggleSnackbar(true, severity.success, 'Details updated successfully');
        });
      })
      .catch((err) => {
        runInAction(() => {
          this.error = err;
          console.error(err);
        });
      })
      .finally(() => {
        this.updateClientConstructionSpecificationsStatus = false;
        LoadingProgressStore.toggleIsLoading(false);
      });
  }

  async createClientConstructionSpecifications(payload) {
    LoadingProgressStore.toggleIsLoading(true);
    return leadHandler
      .createClientConstructionSpecifications(payload)
      .then((response) => {
        runInAction(() => {
          this.updateClientConstructionSpecificationsStatus = true;
          this.refreshLeadDetails += 1;
          SnackbarStore.toggleSnackbar(true, severity.success, 'Details updated successfully');
        });
      })
      .catch((err) => {
        runInAction(() => {
          this.error = err;
          console.error(err);
        });
      })
      .finally(() => {
        this.updateClientConstructionSpecificationsStatus = false;
        LoadingProgressStore.toggleIsLoading(false);
      });
  }

  async createAction(payload) {
    LoadingProgressStore.toggleIsLoading(true);
    return leadHandler
      .createAction(payload)
      .then((response) => {
        runInAction(() => {
          this.createLeadActionStatus = true;
          SnackbarStore.toggleSnackbar(true, severity.success, 'Lead action created successfully');
        });
      })
      .catch((err) => {
        runInAction(() => {
          this.error = err;
          this.createLeadActionStatus = false;
          console.error(err);
        });
      })
      .finally(() => {
        this.createLeadActionStatus = false;
        LoadingProgressStore.toggleIsLoading(false);
      });
  }

  async createCallLogs(payload) {
    LoadingProgressStore.toggleIsLoading(true);
    return leadHandler
      .createCallLogs(payload)
      .then((response) => {
        runInAction(() => {
          this.createLeadCallStatus = true;
          SnackbarStore.toggleSnackbar(true, severity.success, 'Lead call created successfully');
        });
      })
      .catch((err) => {
        runInAction(() => {
          this.error = err;
          this.createLeadCallStatus = false;
          console.error(err);
        });
      })
      .finally(() => {
        this.createLeadCallStatus = false;
        LoadingProgressStore.toggleIsLoading(false);
      });
  }

  async createPaymentAudits(payload) {
    LoadingProgressStore.toggleIsLoading(true);
    return leadHandler
      .createPaymentAudits(payload)
      .then((response) => {
        runInAction(() => {
          this.createLeadPaymentAuditStatus = true;
          SnackbarStore.toggleSnackbar(true, severity.success, 'Lead payment audit created successfully');
        });
      })
      .catch((err) => {
        runInAction(() => {
          this.error = err;
          this.createLeadPaymentAuditStatus = false;
          console.error(err);
        });
      })
      .finally(() => {
        this.createLeadPaymentAuditStatus = false;
        LoadingProgressStore.toggleIsLoading(false);
      });
  }
  async deleteLeads(payload) {
    LoadingProgressStore.toggleIsLoading(true);
    return leadHandler
      .deleteLeads(payload)
      .then((_) => {
        runInAction(() => {
          this.refreshLeadersBoard += 1;
          this.leadsDeletionStatus = true;
          SnackbarStore.toggleSnackbar(true, severity.success, 'Leads deleted successfully');
        });
      })
      .catch((err) => {
        runInAction(() => {
          this.error = err;
          console.error(err);
        });
      })
      .finally(() => {
        LoadingProgressStore.toggleIsLoading(false);
        runInAction(() => {
          this.leadsDeletionStatus = false;
        });
      });
  }

  async createDuplicateLeads(leads, pipelineId) {
    LoadingProgressStore.toggleIsLoading(true);
    return leadHandler
      .createDuplicateLeads(leads, pipelineId)
      .then((_) => {
        runInAction(() => {
          this.refreshLeadersBoard += 1;
          this.leadDuplicateStatus = true;
          SnackbarStore.toggleSnackbar(true, severity.success, 'Leads duplicated successfully');
        });
      })
      .catch((err) => {
        runInAction(() => {
          this.error = err;
          console.error(err);
        });
      })
      .finally(() => {
        LoadingProgressStore.toggleIsLoading(false);
        runInAction(() => {
          this.leadDuplicateStatus = false;
        });
      });
  }

  async massUpdateLeadStatus(payload) {
    LoadingProgressStore.toggleIsLoading(true);
    return leadHandler
      .massUpdateLeadStatus(payload)
      .then((_) => {
        runInAction(() => {
          this.refreshLeadersBoard += 1;
          this.leadsMassStatusUpdateStatus = true;
          SnackbarStore.toggleSnackbar(true, severity.success, 'Leads status updated successfully');
        });
      })
      .catch((err) => {
        runInAction(() => {
          this.error = err;
          console.error(err);
        });
      })
      .finally(() => {
        this.leadsMassStatusUpdateStatus = false;
        LoadingProgressStore.toggleIsLoading(false);
      });
  }

  async notifyLeads(payload) {
    LoadingProgressStore.toggleIsLoading(true);
    return leadHandler
      .notifyLeads(payload)
      .then((_) => {
        runInAction(() => {
          this.refreshLeadersBoard += 1;
          this.leadsNotifyStatus = true;
          SnackbarStore.toggleSnackbar(true, severity.success, 'Leads notified successfully');
        });
      })
      .catch((err) => {
        runInAction(() => {
          this.error = err;
          console.error(err);
        });
      })
      .finally(() => {
        LoadingProgressStore.toggleIsLoading(false);
        runInAction(() => {
          this.leadsNotifyStatus = false;
        });
      });
  }

  async updateLeadSubOwner(payload) {
    LoadingProgressStore.toggleIsLoading(true);
    return leadHandler
      .updateLeadSubOwner(payload)
      .then((_) => {
        runInAction(() => {
          this.leadAssignedStatus = true;
          SnackbarStore.toggleSnackbar(true, severity.success, 'Lead sub-owner updated successfully');
        });
      })
      .catch((err) => {
        runInAction(() => {
          this.error = err;
          console.error(err);
        });
      })
      .finally(() => {
        this.leadAssignedStatus = false;
        LoadingProgressStore.toggleIsLoading(false);
      });
  }

  async assignLead(payload) {
    LoadingProgressStore.toggleIsLoading(true);
    return leadHandler
      .assignLead(payload)
      .then((_) => {
        runInAction(() => {
          this.refreshLeadDetails += 1;
          this.leadAssignedStatus = true;
          SnackbarStore.toggleSnackbar(true, severity.success, 'Lead assigned successfully');
        });
      })
      .catch((err) => {
        runInAction(() => {
          this.error = err;
          console.error(err);
        });
      })
      .finally(() => {
        LoadingProgressStore.toggleIsLoading(false);
        runInAction(() => {
          this.leadAssignedStatus = false;
        });
      });
  }

  setLeadsList(list, columns) {
    runInAction(() => {
      this.leadsList = list;
      this.leadsListColumns = columns;
    });
  }

  setCanPerformMassStatusUpdate(flag) {
    runInAction(() => {
      this.canPerformMassStatusUpdate = flag;
    });
  }

  setRefreshLeadersBoard() {
    runInAction(() => {
      this.refreshLeadersBoard += 1;
    });
  }
}

export default new LeadStore();
